export const getHudVoucherDetailsQueryKey = (
  organizationId,
  propertyId,
  hudVoucherId,
) => ['hudVoucherDetails', organizationId, propertyId, hudVoucherId];

export const getHudVoucherTenantEventsQueryKey = (
  organizationId,
  propertyId,
  hudVoucherId,
) => ['hudVoucherTenantEvents', organizationId, propertyId, hudVoucherId];

export const getHudVoucherStatsQueryKey = (
  organizationId,
  propertyId,
  hudVoucherId,
) => ['hudVoucherStats', organizationId, propertyId, hudVoucherId];

export const getHudVoucherSpecialClaimsQueryKey = (
  organizationId,
  propertyId,
  hudVoucherId,
) => ['hudVoucherSpecialClaims', organizationId, propertyId, hudVoucherId];

export const getHudVoucherMiscAccountingQueryKey = (
  organizationId,
  propertyId,
  hudVoucherId,
) => ['hudVoucherMiscAccounting', organizationId, propertyId, hudVoucherId];

export const getRegularAssistanceQueryKey = (
  organizationId,
  propertyId,
  hudVoucherId,
) => ['hudVoucherRegularAssistance', organizationId, propertyId, hudVoucherId];

export const getHudVoucherAdjustmentsQueryKey = (
  organizationId,
  propertyId,
  hudVoucherId,
) => ['hudVoucherAdjustments', organizationId, propertyId, hudVoucherId];

export const getHudVoucherRepaymentAgreementsQueryKey = (
  organizationId,
  propertyId,
  hudVoucherId,
) => [
  'hudVoucherRepaymentAgreements',
  organizationId,
  propertyId,
  hudVoucherId,
];

export const getPropertyRegularAssistanceQueryKeyPrefix = (
  organizationId,
  propertyId,
) => ['hudVoucherRegularAssistance', organizationId, propertyId];

export const getPropertyHudVoucherQueryKeyPrefixes = (
  organizationId,
  propertyId,
) =>
  [
    'hudVoucherStats',
    'hudVoucherDetails',
    'hudVoucherTenantEvents',
    'hudVouchers',
  ].map((name) => [name, organizationId, propertyId]);
